var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNftTitle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 425,
    height: 55,
    viewBox: "0 0 425 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45 5H40V10H35V15H30V20H25V15H20V10H15V5H10V0H0V55H10V20H15V25H20V30H25V35H30V30H35V25H40V20H45V55H55V0H45V5ZM90 20H65V25H60V50H65V55H90V50H95V45H85V50H70V40H95V25H90V20ZM85 35H70V25H85V35ZM120 10H110V20H100V25H110V50H115V55H130V50H125V45H120V25H130V20H120V10ZM145 25H160V20H140V25H135V50H140V55H160V50H145V25ZM170 20H165V25H160V50H165V55H175V50H170V20ZM225 5H220V0H185V5H180V10H175V20H180V25H185V30H210V35H215V45H210V50H195V45H190V40H175V45H180V50H185V55H220V50H225V45H230V35H225V30H220V25H195V20H190V10H195V5H210V10H215V15H230V10H225V5ZM260 50H245V20H235V50H240V55H265V50H270V20H260V50ZM305 20H280V25H275V50H280V55H305V50H310V45H300V50H285V25H300V30H310V25H305V20ZM335 25H330V30H325V10H315V55H325V45H330V50H335V55H350V50H345V45H340V40H335V35H340V30H345V25H350V20H335V25ZM385 20H360V25H355V50H360V55H385V50H390V45H380V50H365V40H390V25H385V20ZM380 35H365V25H380V35ZM415 20V25H410V30H405V20H395V55H405V40H415V30H425V20H415Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNftTitle);
export default __webpack_public_path__ + "static/media/nftTitle.e99d9aac3168c2de726092dafe837932.svg";
export { ForwardRef as ReactComponent };